export const shareUrls = {
  twitter: "https://twitter.com/intent/tweet?text=",
  facebook: "https://www.facebook.com/sharer/sharer.php?u=",
  whatsapp: "https://api.whatsapp.com/send?text=",
};
